'use client';

import { CardTitle } from '@/components/Shares/CardTitle';
import { CarouselControl } from '@/components/Shares/CarouselControl';
import { useLingui } from '@lingui/react';
import { Box, Card, Group, Image } from '@mantine/core';
import classes from './Brand.module.css';
const Brand: React.FC<{
  pos: number;
  url: string;
}> = ({
  pos,
  url
}) => {
  return <Box className={classes.item} style={{
    '--pos': pos
  } as React.CSSProperties}>
      <Image src={url} w={145} h={50} alt="brand" />
    </Box>;
};
const brands = [{
  pos: 1,
  url: '/assets/brands/1.png'
}, {
  pos: 2,
  url: '/assets/brands/2.png'
}, {
  pos: 3,
  url: '/assets/brands/3.png'
}, {
  pos: 4,
  url: '/assets/brands/4.png'
}, {
  pos: 5,
  url: '/assets/brands/5.png'
}, {
  pos: 6,
  url: '/assets/brands/6.png'
}, {
  pos: 7,
  url: '/assets/brands/7.svg'
}];
export const Brands: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Card bg="var(--navbar-bg-color)" my={12} radius="sm">
      <Group justify="space-between">
        <CardTitle firstText={i18n._('Game providers')} isFirstGradient colorFrom="#B9C7D4" colorTo="#B9C7D4" iconUrl="/assets/title-icons/6.png" mt={4} />
        <CarouselControl link="#" />
      </Group>
      <Group className={classes.wrapper} wrap="nowrap" style={{
      '--quantity': 7
    } as React.CSSProperties}>
        {brands.map(brand => <Brand key={brand.pos} pos={brand.pos} url={brand.url} />)}
      </Group>
    </Card>;
};